module.exports = __webpack_public_path__ + "479de350020b09d0c42bf0c43c953e7e.jpg";